import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import term from '@/components/term'
import material from '@/components/material'
import varieties from '@/components/varieties'
import material_article from '@/components/material_article'
import varieties_article from '@/components/varieties_article'
import search from '@/components/search'


Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      component: index
    },
    {
      path: '/term',
      component: term
    },
    {
      path: '/material',
      component: material,
      name: 'Material',
      meta:{keepAlive:true}
    },
    {
      path: '/varieties',
      component: varieties,
      name: 'Varieties',
      meta:{keepAlive:true}
    },
    {
      path: '/material_article',
      component: material_article,
      name:'materialArticle',
    },
    {
      path: '/varieties_article',
      component: varieties_article,
      name:'varietiesArticle'
    },
    {
      path: '/search',
      component: search,
      name:"search",
      meta:{show:true}
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js